
import { FormState__startLoading, FormState__setValidationResponse_5219762A, FormState_get_empty, RequestedValue$1 } from "../../../Shared/Shared.js";
import { Msg, State } from "./Types.js";
import { Cmd_none, Cmd_batch } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_OfPromise_either } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../../CommunicationV2.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { ofArray, singleton } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { Label_$reflection, DTO_CategoryDetailsDto_$reflection } from "../../../Shared/Category.js";
import { ValidationOnGetRequest } from "../../../ErrorHandling.js";
import { concat } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { CategoryMinimumQuantityId__get_unwrap, LabelId__get_unwrap } from "../../../Shared/Shared.js";
import { string_type, list_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Cmd_errorToast } from "../../../Components/Toast.js";
import { Cmd_ofEffect } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { RouterModule_nav } from "../../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";

export function init(categoryId) {
    return [new State(categoryId, new RequestedValue$1(0, []), new RequestedValue$1(0, []), FormState_get_empty()), Cmd_batch(ofArray([Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), DTO_CategoryDetailsDto_$reflection()));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), concat("/api/categories/", ...LabelId__get_unwrap(categoryId)), (Item) => (new Msg(3, [Item])), (Item_1) => (new Msg(7, [Item_1]))), Cmd_OfPromise_either((url_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_5;
        return ((url_5 = addPrefix(url_3), (refreshOn_1) => fetchWithDecoder(url_5, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_2) => {
            const pr_1 = response_2.arrayBuffer();
            return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), list_type(Label_$reflection())));
        }, refreshOn_1)))(true).then((_arg_1) => {
            const result_3 = _arg_1;
            return (result_3.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_3.fields[0]);
            })())) : (Promise.resolve(result_3.fields[0]));
        });
    })), "/api/categories", (Item_2) => (new Msg(4, [Item_2])), (Item_3) => (new Msg(7, [Item_3])))]))];
}

export function update(msg, state) {
    let xs;
    switch (msg.tag) {
        case 1:
            return [state, Cmd_OfPromise_either((url_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_5;
                return ((url_5 = addPrefix(url_3), (refreshOn_1) => fetchWithDecoder(url_5, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_2) => {
                    const pr_1 = response_2.arrayBuffer();
                    return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), DTO_CategoryDetailsDto_$reflection()));
                }, refreshOn_1)))(true).then((_arg) => {
                    const result_2 = _arg;
                    return (result_2.tag === 1) ? (Promise.resolve((() => {
                        throw new ValidationOnGetRequest(result_2.fields[0]);
                    })())) : (Promise.resolve(result_2.fields[0]));
                });
            })), concat("/api/categories/", ...LabelId__get_unwrap(state.CategoryId)), (Item_2) => (new Msg(3, [Item_2])), (Item_3) => (new Msg(7, [Item_3])))];
        case 2: {
            const response_4 = msg.fields[0];
            if (response_4.tag === 1) {
                return [new State(state.CategoryId, state.Category, state.AllCategories, FormState__setValidationResponse_5219762A(state.FormState, response_4.fields[0])), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.CategoryId, state.Category, state.AllCategories, FormState_get_empty()), (xs = ["settings", "categories"], Cmd_ofEffect((_arg_1) => {
                    RouterModule_nav(ofArray(xs), 1, 1);
                }))];
            }
        }
        case 3:
            return [new State(state.CategoryId, new RequestedValue$1(1, [msg.fields[0]]), state.AllCategories, state.FormState), Cmd_none()];
        case 4:
            return [new State(state.CategoryId, state.Category, new RequestedValue$1(1, [msg.fields[0]]), state.FormState), Cmd_none()];
        case 5:
            return [new State(state.CategoryId, state.Category, state.AllCategories, FormState__startLoading(state.FormState)), Cmd_OfPromise_either((url_6) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_8;
                return ((url_8 = addPrefix(url_6), (refreshOn_2) => fetchWithDecoder(url_8, singleton(new Types_RequestProperties(0, ["DELETE"])), "application/json", (response_5) => {
                    const pr_2 = response_5.arrayBuffer();
                    return pr_2.then((blob_2) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_2)), string_type));
                }, refreshOn_2)))(true);
            })), concat("/api/categories/", LabelId__get_unwrap(state.CategoryId), "/minimum-quantities/", ...CategoryMinimumQuantityId__get_unwrap(msg.fields[0])), (Item_4) => (new Msg(6, [Item_4])), (Item_5) => (new Msg(7, [Item_5])))];
        case 6: {
            const response_7 = msg.fields[0];
            if (response_7.tag === 1) {
                return [new State(state.CategoryId, state.Category, state.AllCategories, FormState__setValidationResponse_5219762A(state.FormState, response_7.fields[0])), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.CategoryId, state.Category, state.AllCategories, FormState_get_empty()), singleton((dispatch) => {
                    dispatch(new Msg(1, []));
                })];
            }
        }
        case 7:
            return [new State(state.CategoryId, state.Category, state.AllCategories, FormState_get_empty()), Cmd_none()];
        default:
            return [new State(state.CategoryId, state.Category, state.AllCategories, FormState__startLoading(state.FormState)), Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_2;
                return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["DELETE"])), "application/json", (response) => {
                    const pr = response.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                }, refreshOn)))(true);
            })), concat("/api/categories/", ...LabelId__get_unwrap(state.CategoryId)), (Item) => (new Msg(2, [Item])), (Item_1) => (new Msg(7, [Item_1])))];
    }
}

